import isEmpty from 'lodash/isEmpty';

export function performAllFlaggedSearch(data, matchId, tournamentName, dataStatus) {
  const filteredByMatchId = filterByMatchId(data, matchId);
  const filteredByTournamentName = filterByTournamentName(filteredByMatchId, tournamentName);
  const filteredByDataStatus = filterByDataStatus(filteredByTournamentName, dataStatus);
  return filteredByDataStatus;
}

export function filterByMatchId(data, matchId) {
  if (isEmpty(data)) return [];
  if (!matchId) return data;
  let result = [];
  result = data.filter((item) => item?.match_id === parseInt(matchId));
  return result;
}

export function filterByTournamentName(data, tournamentName) {
  if (isEmpty(data)) return [];
  if (!tournamentName) return data;
  let result = [];
  result = data.filter((item) => item?.comp_name?.toLowerCase().includes(tournamentName.toLowerCase()));
  return result;
}

export function filterByDataStatus(data, dataStatus) {
  if (isEmpty(data)) return [];
  if (!dataStatus || dataStatus === 'all') return data;
  let result = [];
  result = data.filter((item) => item?.data_status === dataStatus);
  return result;
}
